/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { jiraFieldModelSchema } from './jiraFieldModelSchema';

export const mappingFieldsSchema = z.object({
  get dateFields() {
    return z.array(jiraFieldModelSchema);
  },
  get estimateFields() {
    return z.array(jiraFieldModelSchema);
  },
  get teamFields() {
    return z.array(jiraFieldModelSchema);
  },
});
